"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.interviewPreparationSchema = exports.interviewPreparationRatingSchemas = void 0;
const zod_1 = require("zod");
const interviewPreparationNumberSchema = zod_1.z.preprocess((value) => {
    if (typeof value !== 'string' || !/^-?\d+(?:[.,]\d+)?$/.test(value.trim())) {
        return value;
    }
    return Number(value.trim().replace(',', '.'));
}, zod_1.z.number());
exports.interviewPreparationRatingSchemas = zod_1.z.object({
    internal_calculus: zod_1.z.string().optional().describe('Brouillon de calcul interne'),
    ratingTitle: zod_1.z.string().describe('Contexte de la note'),
    rate: interviewPreparationNumberSchema.describe('Note'),
    comment: zod_1.z.string().describe('Commentaire'),
    weight: interviewPreparationNumberSchema.describe('Ponderation'),
});
const interviewPreparationCandidateGeneralSchema = zod_1.z.object({
    opportunityIntroduction: zod_1.z.string().describe("Details du besoin (quand plus d'1 besoin traité pour le candidat)"),
    candidatePros: zod_1.z
        .array(zod_1.z.object({
        proTitle: zod_1.z.string().describe('Titre'),
        proExplanations: zod_1.z.array(zod_1.z.string()).describe('Details'),
    }))
        .describe('Qualités du candidat'),
    candidateCons: zod_1.z
        .array(zod_1.z.object({
        conTitle: zod_1.z.string().describe('Titre'),
        conExplanations: zod_1.z.array(zod_1.z.string()).describe('Details'),
    }))
        .describe("Points d'attention"),
    questionsForCandidates: zod_1.z
        .array(zod_1.z.object({
        questionContext: zod_1.z.string().describe('Contexte de la question'),
        question: zod_1.z.string().describe('Question'),
        answer: zod_1.z.string().describe('Reponse'),
    }))
        .describe('Questions à poser en entretien'),
});
exports.interviewPreparationSchema = {
    candidateGeneral: interviewPreparationCandidateGeneralSchema,
    general: interviewPreparationCandidateGeneralSchema.extend({
        ratings: zod_1.z.array(exports.interviewPreparationRatingSchemas).describe('Note de cohérence'),
        conclusion: zod_1.z.string().describe('Conclusion'),
    }),
    asideFields: {
        activityAreas: zod_1.z.object({
            activityAreas: zod_1.z.array(zod_1.z.string()).describe('Domaines'),
        }),
        commutingTimeRating: exports.interviewPreparationRatingSchemas,
    },
};
